export enum OS {
    IOS = 'ios',
    ANDROID = 'android',
    WEB = 'web'
}

export enum Platform {
    MOBILE = 'MOBILE',
    DESKTOP = 'DESKTOP',
    TABLET = 'TABLET'
}

export const OS_VERSION_THRESHOLDS = {
    SAFARI_IOS: 14.5,
    CHROME_IOS: 92.1,
    ANDROID: 123,
} as const;

export const VERSION_PATTERNS = {
    SAFARI_IOS: /version\/(\d+(\.\d+)?)/,
    CHROME_IOS: /crios\/(\d+(\.\d+)?)/,
    CHROME_IOS_DETECT: /crios/,
} as const;